module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2_jp.9b116089781fbc58289f8511d66f8b34.png";